export default "__VITE_ASSET__CLHZzNbz__"